import {AxiosResponse} from 'axios';
import {SocialNetworkCity} from '../backend/interfaces/social-network-city';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class SocialNetworkCitiesRepository {
  // Singleton Instance
  private static _instance: SocialNetworkCitiesRepository;

  // Private
  private logger: Logger;

  static get instance(): SocialNetworkCitiesRepository {
    if (!this._instance) {
      this._instance = new SocialNetworkCitiesRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('SocialNetworkCitiesRepository');
  }

  // Get all cities
  public async get(search: string, localize: boolean): Promise<Array<SocialNetworkCity>> {
    // Get cities
    const nameParam = search.trim().length > 0 ? `&name=${search}` : '';
    const response: AxiosResponse<Array<SocialNetworkCity>> = await BackendApiManager.instance.get<
      Array<SocialNetworkCity>
    >(`/social-network/cities?localize=${localize}${nameParam}`);

    return response.data;
  }

  // Get a city by id
  public async getById(id: string, localize: boolean): Promise<Array<SocialNetworkCity>> {
    // Get city
    const response: AxiosResponse<Array<SocialNetworkCity>> = await BackendApiManager.instance.get<
      Array<SocialNetworkCity>
    >(`/social-network/cities/${id}?localize=${localize}`);

    return response.data;
  }
}
